var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelFoursquare14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCFDFD",
  d: "M9.264 3c.656 0 .832.358.69 1.023-.07.326-.193.916-.32 1.537l-.087.415c-.186.899-.362 1.752-.39 1.857-.059.23-.151.623-.724.623H7.068c-.055 0-.055 0-.11.052-.036.035-2.144 2.38-2.144 2.38-.165.182-.439.15-.538.111S4 10.843 4 10.528V3.723c0-.28.181-.724.798-.724Zm-.485.885H5.194a.273.273 0 0 0-.271.26v5.309c0 .016.013.02.026.005 0 0 1.32-1.52 1.468-1.695s.213-.202.432-.202h1.205a.29.29 0 0 0 .274-.21c.017-.078.157-.78.188-.921.03-.142-.106-.287-.245-.287H6.795c-.196 0-.337-.133-.337-.321v-.204c0-.188.14-.316.336-.316h1.74c.124 0 .257-.106.279-.207l.188-.937a.225.225 0 0 0-.222-.274"
}))));
export default SvgChannelFoursquare14;